import { Button, Card, CardActionArea, CardActions, CardContent, Typography } from '@mui/material';
import React from 'react';
import useDebugInformation from '../../../../../../hooks/useDebugInformation';
import { fullReset } from '../../../../../../utilities/general/index';
import { NavigateFunction, useNavigate } from 'react-router-dom';
import { useAppSelector } from "@store/hooks";
import { ui } from '../../../../../../interfaces/interfaces';

const name = "CompleteForm";

type CompleteFormProps = {
    parent: string;
}

const resetForm = async (navigate: NavigateFunction) => {
    await fullReset(navigate, "Booking Completed");
};

const CompleteForm: React.FC<CompleteFormProps> = ({ parent }) => {
    const bookingCompletionMsg = useAppSelector(({ ui }) => ui.BookingCompletionMsg);
    const navigate = useNavigate();
    useDebugInformation(name, { bookingCompletionMsg });

    return (
        <Card >
            <CardActionArea>
                {/* <CardMedia
                    component="img"
                    src={RightioLogo}
                /> */}
                <CardContent>
                    <Typography gutterBottom variant="h3" component="div">
                        Booking is completed
                    </Typography>
                    {bookingCompletionMsg.split("\n").map((item, index) =>
                        <Typography variant="h5" key={index} textAlign="left" sx={{ p: 1 }}>
                            {item}
                        </Typography>
                    )}
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button size="large" color="primary" variant='contained' onClick={() => resetForm(navigate)}>
                    Finish
                </Button>
                {!bookingCompletionMsg && <Button size="large" color="secondary" variant='contained' onClick={() => ui.ActiveStep = 2}>
                    Recover
                </Button>}
            </CardActions>
        </Card>
    );
};

CompleteForm.displayName = name;


export default React.memo(CompleteForm);


